import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';

import logo from '../../assets/images/verisign.png';

const StyledImg = styled.img`
  height: ${remCalc(44)};
  margin-bottom: ${remCalc(8)};
`;

const VeriSignLogo = () => <StyledImg src={logo} alt={''} />;

export default VeriSignLogo;
